import { useState, useEffect } from 'react';
import { EMPTY_TEXT, MimeTypeService } from "../../common";
import { QuestionnaireEvaluationQuestionType } from "../../questionnaireEvaluation";
import { MIC_PROGRESSIVE_CONSTANT, PhotoCaptureConstants, STATUS_CODE } from '../constants';
import { getSourceNameByAssignmentTypeAndSubType, isArtifactIdExist, attachedArtifactIdsToUpdate, createAndUpdateAttachmentHistory, getFileDescriptionByAttributeType, processVinData, shouldRenderProgressiveScreens } from '../utilities';
import { PhotoCaptureAttributeType, PhotoCaptureImageDescription } from '../enums';
export const usePhotoCaptureWorker = ({ companyCode, attachments, questionnaireQuestionId, isSaveSuccess, evaluationDocId, questionnaireId, contextId, isContextUpdated, photoCaptureAttachmentInfo, isTermsAndConditionAccepted, assignmentSubType, assignmentType, parentQuestionId, attachedArtifactIds, questionSubType, ocrText, sequenceScreenName, prgMiscImage, vehicleInfoData, selectedInfoEntries, isErrorOccured, vehicleAttributes, isEnabled, vinErrorState, hasVehicleAttributes, photoCaptureUpdateAttachedArtifactIdSuccessAction, questionnaireEvaluationQuestionGetAction, photoCaptureResetContextAction, questionnaireEvaluationSaveRequestAction, photoCaptureUpdateContextDataAction, photoCaptureAttachmentDataAction }) => {
    const storeImageData = [];
    attachments &&
        attachments.length &&
        attachments.map((attachmentData) => {
            const attachmentFile = {
                docUID: attachmentData.fileId,
                fileName: attachmentData.imageName,
                fileDescription: attachmentData.fileDescription,
                commentText: attachmentData.commentText || '',
                thumbnailDocUId: attachmentData.thumbFileId,
                attachmentIdentifier: attachmentData.id,
                parentQuestionId: attachmentData.parentQuestionId,
                questionnaireQuestionId: attachmentData.questionnaireQuestionId,
                isParentImage: attachmentData.isParentImage,
                parentIdentifier: attachmentData.parentIdentifier,
                damageName: attachmentData.damageName,
                additionalImageTag: attachmentData.additionalImageTag,
                damageId: attachmentData.damageId,
                ocrText: attachmentData.ocrText,
                historyInfo: attachmentData.historyInfo,
                folderModelInfo: attachmentData.folderModelInfo,
                imageSize: attachmentData.imageSize,
                thumbnailImageSize: attachmentData.thumbnailImageSize,
                imageDocId: attachmentData.imageDocId,
                thumbnailDocId: attachmentData.thumbnailDocId
            };
            storeImageData.push(attachmentFile);
        });
    const [imageData, setImageData] = useState(storeImageData);
    const [shouldUpdatedContext, setShouldUpdatedContext] = useState(false);
    const existingHistoryInfos = imageData.map((attachmentData) => ({
        fileDescription: attachmentData.fileDescription,
        historyInfo: attachmentData.historyInfo,
        additionalImageTag: attachmentData.additionalImageTag
    }));
    const [attachmentHistoryInfo, setAttachmentHistoryInfo] = useState(existingHistoryInfos);
    const [isImageUpdated, setIsImageUpdated] = useState(false);
    const updatePageAttachmentHistory = (docUID, imageHistoryDetails, isNewImageTaken) => {
        const isParentImage = sequenceScreenName !== MIC_PROGRESSIVE_CONSTANT.Child;
        const fileDescription = getFileDescriptionByAttributeType(questionSubType, isParentImage, sequenceScreenName);
        const updatedImageHistory = createAndUpdateAttachmentHistory(attachmentHistoryInfo, fileDescription, docUID, imageHistoryDetails, isNewImageTaken, prgMiscImage && prgMiscImage.additionalImageTag);
        setAttachmentHistoryInfo(updatedImageHistory);
    };
    const attachmentInfo = (attachmentIdentifier) => photoCaptureAttachmentInfo &&
        photoCaptureAttachmentInfo.find((attachmentData) => attachmentData[0].id === attachmentIdentifier);
    const changeQuestion = (evaluationDocId, questionnaireId, questionnaireQuestionId, questionType) => {
        !shouldUpdatedContext && photoCaptureResetContextAction();
        setIsImageUpdated(false);
        const questionGetParams = {
            companyCode,
            evaluationDocId: parseInt(evaluationDocId),
            questionnaireId: parseInt(questionnaireId),
            questionnaireQuestionId,
            questionType
        };
        questionnaireEvaluationQuestionGetAction(questionGetParams);
    };
    useEffect(() => {
        if (attachments && attachments.length) {
            setImageData(storeImageData);
        }
        else {
            setImageData([]);
        }
    }, [questionnaireQuestionId]);
    useEffect(() => {
        if (attachments.length && !imageData.length && shouldRenderProgressiveScreens(questionSubType)) {
            setImageData(storeImageData);
        }
    }, [attachments]);
    useEffect(() => {
        isSaveSuccess &&
            evaluationDocId &&
            questionnaireId &&
            questionnaireQuestionId &&
            changeQuestion(evaluationDocId, questionnaireId, questionnaireQuestionId, QuestionnaireEvaluationQuestionType.NEXT);
    }, [isSaveSuccess]);
    useEffect(() => {
        if (evaluationDocId &&
            questionnaireQuestionId &&
            isContextUpdated &&
            questionSubType !== PhotoCaptureAttributeType.SUMMARY) {
            let saveRequestAnswer;
            imageData.map((attachmentData) => {
                const attachedImageData = attachmentInfo(attachmentData.attachmentIdentifier);
                saveRequestAnswer = [...(saveRequestAnswer || []), ...(attachedImageData || [])];
            });
            const saveQuestionParams = {
                isCacheOnly: false,
                evalId: evaluationDocId,
                coCode: companyCode,
                shouldIncludeEvalution: false,
                questionsData: [
                    {
                        qustnnrQustnId: questionnaireQuestionId,
                        answer: (questionSubType === PhotoCaptureAttributeType.VIN_CAPTURE &&
                            isEnabled &&
                            isEnabled('shouldAllowVinDecode') &&
                            JSON.stringify([
                                Object.assign(Object.assign({}, ((saveRequestAnswer && saveRequestAnswer[0]) || {})), { vehicleVinData: vehicleInfoData })
                            ])) ||
                            JSON.stringify(saveRequestAnswer) ||
                            'NA'
                    }
                ]
            };
            questionnaireEvaluationSaveRequestAction(saveQuestionParams);
        }
    }, [isContextUpdated]);
    useEffect(() => {
        if (isImageUpdated || shouldUpdatedContext) {
            const contextDataUpdateInput = {
                attachmentInfo: photoCaptureAttachmentInfo,
                documentId: evaluationDocId,
                fraudWarningAccept: PhotoCaptureConstants.ZERO_STRING,
                isTermsAndConditionAccepted: isTermsAndConditionAccepted ? PhotoCaptureConstants.Y : PhotoCaptureConstants.N,
                status: null,
                vehicle: null
            };
            photoCaptureUpdateContextDataAction(contextDataUpdateInput, contextId, companyCode);
        }
    }, [photoCaptureAttachmentInfo, shouldUpdatedContext]);
    const saveQuestionWithEmptyStringAnswer = () => {
        if (evaluationDocId && questionnaireQuestionId) {
            const saveQuestionParams = {
                isCacheOnly: false,
                evalId: evaluationDocId,
                coCode: companyCode,
                shouldIncludeEvalution: false,
                questionsData: [
                    {
                        qustnnrQustnId: questionnaireQuestionId,
                        answer: EMPTY_TEXT
                    }
                ]
            };
            questionnaireEvaluationSaveRequestAction(saveQuestionParams);
        }
    };
    const moveNext = (isAdditionalPhotoUpdated = false, isOptionalQuestion = false) => {
        if (isOptionalQuestion) {
            saveQuestionWithEmptyStringAnswer();
        }
        else if (isImageUpdated) {
            const attachmentRequest = [];
            let vehicleInfo = null;
            imageData.map((attachmentData) => {
                const attachmentFile = {
                    fileDescription: attachmentData.fileDescription,
                    commentText: attachmentData.commentText || '',
                    fileName: attachmentData.fileName,
                    mimeType: MimeTypeService.lookup(attachmentData.fileName),
                    attachmentDocUId: attachmentData.docUID,
                    attachmentIdentifier: attachmentData.attachmentIdentifier,
                    thumbnailDocUId: attachmentData.thumbnailDocUId,
                    isParentImage: attachmentData.isParentImage,
                    parentIdentifier: attachmentData.parentIdentifier,
                    imageSize: attachmentData.imageSize,
                    thumbnailImageSize: attachmentData.thumbnailImageSize,
                    imageDocId: attachmentData.imageDocId,
                    thumbnailDocId: attachmentData.thumbnailDocId
                };
                if (questionSubType === PhotoCaptureAttributeType.WIDE_ENHANCED ||
                    questionSubType === PhotoCaptureAttributeType.CLOSEUP_ENHANCED) {
                    attachmentRequest.push(Object.assign(Object.assign({}, attachmentFile), { damageName: attachmentData.damageName, additionalImageTag: attachmentData.additionalImageTag, damageId: attachmentData.damageId }));
                }
                else if (questionSubType === PhotoCaptureAttributeType.VIN_CAPTURE &&
                    isEnabled &&
                    isEnabled('shouldAllowVinDecode')) {
                    const isAmbiguityResolved = !!vehicleInfoData && !!vehicleInfoData.Vehicle;
                    if (attachmentData.fileDescription === PhotoCaptureImageDescription.VEHICLE_IDENTIFICATION) {
                        if (!isErrorOccured && // will check if isErrorOccured is true for VSS service call failed for any reason
                            isAmbiguityResolved && // fully decoded vin or was partial but user resolved the ambiguity so its fully decoded
                            selectedInfoEntries && // default data as empty object is set for selectedInfoEntries from their domain only
                            hasVehicleAttributes &&
                            !vinErrorState) {
                            vehicleInfo = {
                                vinInfo: processVinData(vehicleInfoData, selectedInfoEntries),
                                attributeInfo: vehicleAttributes || null,
                                statusCode: STATUS_CODE,
                                failureReason: null
                            };
                        }
                        else if (!isErrorOccured && // will check if isErrorOccured is true for VSS service call failed for any reason
                            !isAmbiguityResolved && // user not resolved the ambiguity, so its partial decoded vin
                            !vinErrorState && // will check if vinErrorState is defined then vehicleInfo data prepared to send with failureReason
                            !hasVehicleAttributes // if ambiguity not resolved then attribute service will not call so value will be false only
                        ) {
                            vehicleInfo = {
                                vinInfo: processVinData(vehicleInfoData, selectedInfoEntries),
                                attributeInfo: null,
                                statusCode: STATUS_CODE,
                                failureReason: null
                            };
                        }
                        else if (isErrorOccured && // will check if isErrorOccured is true for VSS service call failed for any reason
                            vinErrorState && // will check if vinErrorState is defined then vehicleInfo data prepared to send with failureReason
                            !hasVehicleAttributes // VSS service call failed then attribute service will not call so value will be false only
                        ) {
                            vehicleInfo = {
                                vinInfo: null,
                                attributeInfo: null,
                                statusCode: null,
                                failureReason: vinErrorState && `${vinErrorState.errorCode}-${vinErrorState.error}`
                            };
                        }
                        else if (isErrorOccured && // will check if isErrorOccured is true for attribute call failed for any reason
                            vehicleInfoData && // will only send vinInfo as attribute call dispatch only after VSS service based on VID
                            !hasVehicleAttributes // as isErrorOccured is true then hasVehicleAttributes is false
                        ) {
                            vehicleInfo = {
                                vinInfo: processVinData(vehicleInfoData, selectedInfoEntries),
                                attributeInfo: null,
                                statusCode: STATUS_CODE,
                                failureReason: null
                            };
                        }
                    }
                    attachmentRequest.push(attachmentFile);
                }
                else {
                    attachmentRequest.push(attachmentFile);
                }
            });
            const sourceName = getSourceNameByAssignmentTypeAndSubType(assignmentType, assignmentSubType);
            photoCaptureAttachmentDataAction(attachmentRequest, companyCode, sourceName, parentQuestionId, questionnaireQuestionId, ocrText, attachmentHistoryInfo, imageData, vehicleInfo);
        }
        else if (isAdditionalPhotoUpdated) {
            setShouldUpdatedContext(true);
        }
        else {
            evaluationDocId &&
                questionnaireId &&
                questionnaireQuestionId &&
                changeQuestion(evaluationDocId, questionnaireId, questionnaireQuestionId, QuestionnaireEvaluationQuestionType.NEXT);
        }
    };
    const movePrevious = () => {
        const attachedArtifactId = {
            parentQuestionId,
            questionnaireQuestionId
        };
        if (!isArtifactIdExist(attachedArtifactIds, attachedArtifactId)) {
            questionnaireQuestionId &&
                photoCaptureUpdateAttachedArtifactIdSuccessAction(attachedArtifactIdsToUpdate(attachedArtifactIds, attachedArtifactId));
        }
        evaluationDocId &&
            questionnaireId &&
            questionnaireQuestionId &&
            changeQuestion(evaluationDocId, questionnaireId, questionnaireQuestionId, QuestionnaireEvaluationQuestionType.PREVIOUS);
    };
    return {
        moveNext,
        imageData,
        setIsImageUpdated,
        setImageData,
        movePrevious,
        isImageUpdated,
        updatePageAttachmentHistory
    };
};
//# sourceMappingURL=usePhotoCaptureWorker.js.map